export default "__VITE_ASSET__68598ab3__"